import React, { useState } from "react";
import { ResponsiveImage } from "~assets/frontend/elements/responsive-image/ResponsiveImage";
import { getId } from "~assets/frontend/_util/getId";
import { Icon } from "~assets/frontend/elements/icon/Icon";
import { dispatchTrackingEvent } from "~assets/global/tracking/tracking-event";
export const SearchResultImage = ({ icon, image, title, link, overline, intro, imageBorder }) => {
    const [uuid, setUuid] = useState(getId);
    // TODO: Just use one image for all breakpoints? They all have the same aspect ratio and almost the same size.
    //       It just feels like a waste of processing time and resources to generate so many images.
    const sizes = {
        extraSmall: {
            w: 256,
            h: 165,
        },
        small: {
            w: 264,
            h: 176,
        },
        medium: {
            w: 318,
            h: 212,
        },
        large: {
            w: 278,
            h: 185,
        },
        extraLarge: {
            w: 216,
            h: 144,
        },
    };
    const trackSearchResult = (event) => {
        const uiEvent = {
            name: "ui",
            payload: {
                ui_component: "frm-search",
                ui_function: "navigate",
                ui_action: "result",
                ui_target: event.currentTarget,
            },
        };
        dispatchTrackingEvent(uiEvent);
    };
    return (React.createElement("a", { href: link, "aria-labelledby": uuid, className: "group/result-image", onClick: trackSearchResult },
        image && (React.createElement(ResponsiveImage, Object.assign({}, image, { imgClass: "bg-anthracite-15 block" + (imageBorder ? " border-1 border-anthracite-15" : ""), pictureClass: "block", wrapperClass: "mb-12 block", sizes: sizes, caption: "", copyright: "" }))),
        overline && React.createElement("p", { className: "text-black-40" }, overline),
        React.createElement("h4", { className: "inline-flex items-center transition-colors group-hover/result-image:text-red-100" },
            icon && icon.position === "start" && (React.createElement(Icon, { _id: getId(), _name: "IconStruct", identifier: icon.identifier, className: "mr-6 before:bg-black-100 group-hover/result-image:before:bg-red-100 group-focus/result-image:before:bg-red-100" })),
            React.createElement("span", { id: uuid }, title),
            icon && icon.position === "end" && (React.createElement(Icon, { _id: getId(), _name: "IconStruct", identifier: icon.identifier, className: "ml-6 before:bg-black-100 group-hover/result-image:before:bg-red-100 group-focus/result-image:before:bg-red-100" })))));
};
